import React from 'react';
import cn from 'classnames';
import styles from './keyboardinput.module.scss';

const inputField = ({
  field,
  type,
  // id,
  value,
  placeholder,
  name,
  onChange,
  // onClick,
  customClass,
  serverAppTheme
}) => {
  const handleBlur = () => {
    const element = document.querySelector('#input');
    element.blur();
  };

  return (
    <div className="col-12 p-0 large-input row mx-0 justify-content-center">
      <input
        {...field}
        name={name}
        className={cn(customClass, 'form-control fs-32 text-left', name === 'tipsAmount' && 'pl-3', styles.inputField)}
        type={type}
        style={{ border:'0', borderBottom:serverAppTheme? serverAppTheme.inputBorder_Bottom :'2px solid #85888C', background:serverAppTheme? serverAppTheme.inputBg :'#393F44', fontFamily:'Poppins', height:'7vh', borderRadius:'0', fontSize:name === 'tipsAmount' && 'Max(3.2vw, 3.2vh)', color:serverAppTheme ? serverAppTheme.primary_text : 'white', '--placeholder-color': serverAppTheme ? serverAppTheme?.input_placeholder : '#ACABAB'}}
        onChange={() => onChange()}
        id="input"
        onFocus={() => handleBlur()}
        placeholder={placeholder}
        value={value}
      />
    </div>
  );
};

export default inputField;
